;(function() {
  'use strict'

  Service.$inject = ["$state", "$log", "glPrefs"];
  angular.module('core.services').service('surveyShieldService', Service)

  /* @ngInject */
  function Service($state, $log, glPrefs) {
    var log = $log.create('surveyShield')
    var prefs = glPrefs.create('surveyShield')
    var PREF = 'fj39j2ksc'
    var ONCE_ONLY = ['61ec84fa-232f-4292-b262-5fae273676ff']

    function forSurvey(surveyId) {
      if (!surveyId) {
        return log.error('no survey id')
      }
      return new Shield(surveyId)
    }

    function Shield(surveyId) {
      this.surveyId = surveyId

      return this
    }

    Shield.prototype.isLocked = function(token, channel) {
      var responses

      if (channel) {
        var full = false
        switch (channel.type) {
          case channel.Type.CUSTOM:
          case channel.Type.KIOSK:
          case channel.Type.EXTERNAL_PANEL:
            full = channel.responseCount >= channel.responseLimit
            break
          case channel.Type.PANEL:
            full = channel.responseCount >= channel.panel.requiredCompletes
            break
        }
        if (full) {
          console.log('locked: channel has reached its target')
          return true
        }
      }

      // if a channel is provided - ignore tokens and do it differently (!)
      if (channel && channel.type === channel.Type.CUSTOM) {
        responses = getResponses({
          surveyId: this.surveyId,
          channelId: channel.id,
        })
        if (!channel.survey.allowMultipleResponses) {
          if (responses.length > 0) {
            console.log(
              'locked: device has already responded and channel does not allow multiple responses'
            )
            return true
          }
        }
        return false
      }

      responses = getResponses({ surveyId: this.surveyId })

      // locked if a token is provided AND it is not a real token
      if (token && !isToken(token)) {
        console.log('locked: token provided is not valid')
        return true
      }

      // locked if the survey is flagged to be completed only once (regardless of token)
      if (_.includes(ONCE_ONLY, this.surveyId)) {
        if (responses.length > 0) {
          console.log(
            'locked: survey has once-only gate and device has already responded'
          )
          return true
        }
      }

      // locked if the survey was exited
      if (_.some(responses, { didExit: true })) {
        console.log(
          'locked: device cannot attempt survey again after they were exited'
        )
        return true
      }

      // locked if the survey hit quota
      if (_.some(responses, { didHitQuota: true })) {
        console.log(
          'locked: device cannot attempt survey again after hitting a quota'
        )
        return true
      }

      // locked if the survey was quality exited
      if (_.some(responses, { didQualityExit: true })) {
        console.log(
          'locked: device cannot attempt survey again after they were quality exited'
        )
        return true
      }

      // locked if the token has already been used with a response
      var tokenUsed = !!_.find(responses, { token: token })
      if (tokenUsed) {
        console.log('locked: device has already responded with this token')
        return true
      }
    }

    Shield.prototype.hasResponse = function() {
      return getResponses({ surveyId: this.surveyId }).length > 0
    }

    Shield.prototype.registerResponse = function(
      token,
      didExit,
      didHitQuota,
      didQualityExit,
      channel
    ) {
      var self = this

      registerResponse({
        surveyId: self.surveyId,
        channelId: channel && channel.id,
        token: token,
        createdAt: moment().toISOString(),
        didExit: didExit,
        didHitQuota: didHitQuota,
        didQualityExit: didQualityExit,
      })
    }

    return {
      forSurvey: forSurvey,
    }

    function getResponses(filter) {
      var tokens = prefs.get(PREF) || []
      return _.filter(tokens, filter)
    }

    function registerResponse(data) {
      // if token is invalid, remove it
      // we still want to record the response
      if (data.token && !isToken(data.token)) {
        data.token = null
        log.error('invalid token', data)
      }

      var tokens = getResponses()
      tokens.push(data)
      prefs.set(PREF, tokens)
    }

    function isToken(token) {
      return _.isString(token) && token.length === 8
    }
  }
})()
